import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { config } from 'config/env';
import { DURATION_MS } from 'app/constants/CronTimes';
import type { RootState } from 'redux/types';

const apiUrl = config.jusfyBackend.apiUrl;

export async function getBulkQueriesHability(clientId: number): Promise<boolean> {
  const res = await axios.get<{ enabled: boolean }>(
    `${apiUrl}/bulk-queries-hability/${clientId}`,
  );
  return res.data.enabled;
}

export function useBulkQueriesHability(): boolean {
  const clientId = useSelector(
    (state: RootState) => state.auth.user?.client_id,
  );

  const { data } = useQuery<boolean>({
    queryKey: ['bulk-queries-hability', clientId],
    queryFn: () => getBulkQueriesHability(clientId as number),
    enabled: !!clientId,
    staleTime: DURATION_MS.FIVE_MINUTES,
  });

  return !!data;
}
